module.exports = __webpack_public_path__ + "img/index_slide_main3.98a73f4a.jpg";